
<div class="row">
    <div class="col-12">
        <form [formGroup]= "formGeometry" (ngSubmit)= "onSubmit()">
            <div class="map-container">
                <div class="map-frame">
                <div id="map4">
                </div>
                </div>
            </div>
        </form>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <button mat-raised-button >{{'SYSTEM.BACK' | translate}}</button>
        <button mat-raised-button >{{'REGISTER.CONFIRM_CHANGES' | translate}}</button>
    </div>
</div>